import React, { createContext, useContext, useEffect, useState } from "react";
import { custLogin, custRegister, custMe } from "../lib/api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("fp_customer_token");
    if (!token) {
      setLoading(false);
      return;
    }
    custMe()
      .then(setCustomer)
      .catch(() => localStorage.removeItem("fp_customer_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { token, user } = await custLogin({ email, password });
    localStorage.setItem("fp_customer_token", token);
    setCustomer(user);
    return user;
  };

  const register = async (payload) => {
    const { token, user } = await custRegister(payload);
    localStorage.setItem("fp_customer_token", token);
    setCustomer(user);
    return user;
  };

  const logout = () => {
    localStorage.removeItem("fp_customer_token");
    setCustomer(null);
  };

  return (
    <AuthContext.Provider value={{ customer, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
